import { useQuery } from "@tanstack/react-query";
import { ClientKeys } from "web_myplann/Api/Client/ClientKeys";
import {
	getClientIdentificationDocumentsV2,
	IdentificationDocumentStateEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

// The server rejects limit > 20 and its default page covers a realistic
// client's document count, so no explicit limit is sent.
export const useIdentificationDocumentsQuery = (
	state: IdentificationDocumentStateEnum = IdentificationDocumentStateEnum.Active,
) => {
	return useQuery({
		queryKey: ClientKeys.identificationDocuments(state),
		queryFn: processResponse(() => getClientIdentificationDocumentsV2(state)),
	});
};
